
import {
    DATATABLE_EXPORT,
} from "../../../../Config/ApiUrl";
import * as actions from "../../../../Config/ApiUrl";
import { isNull } from "lodash";
import {urlGenerator} from "../../../../Helpers/AxiosHelper";

export const RecommendClassTableSchema = {
    components: {  },

    data() { 
        return {
            DATATABLE_EXPORT,
            deleteLoader: false,
            selectedUrl: "",
            Endpoint:  "transaction/placement/getRecommendClass" ,
            tableId: "invoice-approval-recommend-class-table",
            rowData: {},
            tableColumns: [
                {
                    title: "Product Name",
                    type: "custom-html",
                    key: "product",
                    modifier: (value) => {
                        return isNull(value) ? "" : value.name;
                    },
                },
                {
                    title: "Package Name",
                    type: "text",
                    key: "package_name"
                },
                {
                    title: "Monday",
                    type: "custom-html",
                    key: "child",
                    modifier: (children) => {
                        if (!Array.isArray(children)) return "";
                        const monday = children.find(c => c.start_time_1 || c.end_time_1);
                        if (!monday) return "";
                        const start = monday.start_time_1?.slice(0, 5) || "";
                        const end = monday.end_time_1?.slice(0, 5) || "";
                        return `${start} - ${end}`;
                    },
                },
                {
                    title: "Tuesday",
                    type: "custom-html",
                    key: "child",
                    modifier: (children) => {
                        if (!Array.isArray(children)) return "";
                        const tuesday = children.find(c => c.start_time_2 || c.end_time_2);
                        if (!tuesday) return "";
                        const start = tuesday.start_time_2?.slice(0, 5) || "";
                        const end = tuesday.end_time_2?.slice(0, 5) || "";
                        return `${start} - ${end}`;
                    },
                },
                {
                    title: "Wednesday",
                    type: "custom-html",
                    key: "child",
                    modifier: (children) => {
                        if (!Array.isArray(children)) return "";
                        const wed = children.find(c => c.start_time_3 || c.end_time_3);
                        if (!wed) return "";
                        const start = wed.start_time_3?.slice(0, 5) || "";
                        const end = wed.end_time_3?.slice(0, 5) || "";
                        return `${start} - ${end}`;
                    },
                },
                {
                    title: "Thursday",
                    type: "custom-html",
                    key: "child",
                    modifier: (children) => {
                        if (!Array.isArray(children)) return "";
                        const thu = children.find(c => c.start_time_4 || c.end_time_4);
                        if (!thu) return "";
                        const start = thu.start_time_4?.slice(0, 5) || "";
                        const end = thu.end_time_4?.slice(0, 5) || "";
                        return `${start} - ${end}`;
                    },
                },
                {
                    title: "Friday",
                    type: "custom-html",
                    key: "child",
                    modifier: (children) => {
                        if (!Array.isArray(children)) return "";
                        const fri = children.find(c => c.start_time_5 || c.end_time_5);
                        if (!fri) return "";
                        const start = fri.start_time_5?.slice(0, 5) || "";
                        const end = fri.end_time_5?.slice(0, 5) || "";
                        return `${start} - ${end}`;
                    },
                },
                {
                    title: "Start Date",
                    type: "text",
                    key: "start_date",
                },
                {
                    title: "Due Date",
                    type: "text",
                    key: "due_date",
                },
                {
                    title: "Invoice Type",
                    type: "text",
                    key: "invoice_type",
                },
            ],
            actionObj: {
                title: this.$t("action"),
                type: "action",
            },
            options: {
                name: "RecommendClassTable",
                url: "transaction/placement/getRecommendClass?placement_id=" + this.placementId,
                showHeader: true,
                enableHighlights: true,
                // enableRowSelect: true,
                enableSaveFilter: true,
                columns: [],
                actions: [
                ],
                showFilter: false,
                showSearch: false,
                showCount: false,
                showClearFilter: false,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 20,
                showAction: true,
                orderBy: "desc",
                actionType: "default",
            },
        };
    },
    methods: {},
};
